"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const material_1 = require("@mui/material");
const IconButton_1 = tslib_1.__importDefault(require("@mui/material/IconButton"));
const MenuToggle = (0, material_1.styled)(IconButton_1.default)(({ theme }) => ({
    float: "left",
    marginRight: "auto",
    width: theme.spacing(6),
    height: theme.spacing(6),
    marginLeft: theme.spacing(1.5),
    marginBottom: theme.spacing(2),
    color: theme.palette.text.secondary,
}));
exports.default = MenuToggle;
